import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BureauDigilockerGenerateAuthURL, BureauDigilockerGetDetails, DigioKyc_BankAccountVerification, DigioKyc_BankStatementAnalysis, DigioKyc_GSTVerification, DigioKyc_PANToGSTVerification, DigioKyc_PanVerification, KycGateway_Authenticate, KycGateway_GenerateOtp, KycGateway_VerifyGstNo, KycGateway_VerifyOtp, KycGateway_VerifyPanDetails, ScoremeAadhaarOtpGeneration, ScoremeAadhaarOtpVerification, ScoremeDocumentConsentStatus, ScoremeInitiateDigilocker, ScoremePanVerification } from 'src/app/GlobalVariable';
import { AadhaarOKYCResponseDTO, AadharOtpRequestDTO, AadharResponseDTO, AuthenticationResponse, BureauDigilockerGenerateAuthUrlRequestDTO, BureauDigilockerGenerateAuthUrlResponse, BureauDigilockerGetDetailsRequestDTO, BureauDigilockerGetDetailsResponse, GstInRequestDTO, GstInResponseDTO, PanVerificationRequestDTO, PanVerificationResponse, Scoreme_AadhaarOtpGenerationRequestDTO, Scoreme_AadhaarOtpGenerationResponse, Scoreme_AadhaarOtpVerificationRequestDTO, Scoreme_AadhaarOtpVerificationResponse, Scoreme_DocumentConsentStatusRequestDTO, Scoreme_DocumentConsentStatusResponse, Scoreme_InitiateDigilockerReponse, Scoreme_InitiateDigilockerRequestDTO, ScoremeKYC_PanVerificationDTO, ScoremeKYC_PanVerificationResponse, DigioPanVerificationRequestDTO,
  DigioPanVerificationResponseDTO,
  DigioGSTVerificationRequestDTO,
  DigioGSTVerificationResponseDTO,
  DigioPANToGSTVerificationRequestDTO,
  DigioPANToGSTVerificationResponseDTO,
  DigioBankAccountVerificationRequestDTO,
  DigioBankAccountVerificationResponseDTO,
  DigioBankStatementAnalysisResponseDTO } from './Kyc.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KycgatewayService {

  constructor() { }
  http = inject(HttpClient)


  KycGateway_VerifyPanDetails(requestDTO: PanVerificationRequestDTO): Observable<PanVerificationResponse> {
    return this.http.post<PanVerificationResponse>(KycGateway_VerifyPanDetails, requestDTO);
  }

  KycGateway_VerifyGstNo(requestDTO: GstInRequestDTO): Observable<GstInResponseDTO> {
    return this.http.post<GstInResponseDTO>(KycGateway_VerifyGstNo, requestDTO);
  }

  ScoremeKYC_PanVerification(requestDTO: ScoremeKYC_PanVerificationDTO): Observable<ScoremeKYC_PanVerificationResponse> {
    return this.http.post<ScoremeKYC_PanVerificationResponse>(ScoremePanVerification, requestDTO)
  }

  ScoremeKYC_InitiateDigilocker(requestDTO: Scoreme_InitiateDigilockerRequestDTO): Observable<Scoreme_InitiateDigilockerReponse>{
    return this.http.post<Scoreme_InitiateDigilockerReponse>(ScoremeInitiateDigilocker, requestDTO)
  }

  Scoreme_DocumentConsentStatus(requestDTO: Scoreme_DocumentConsentStatusRequestDTO): Observable<Scoreme_DocumentConsentStatusResponse>{
    return this.http.post<Scoreme_DocumentConsentStatusResponse>(ScoremeDocumentConsentStatus, requestDTO)
  }

  Scoreme_AadhaarOtpGeneration(requestDTO: Scoreme_AadhaarOtpGenerationRequestDTO): Observable<Scoreme_AadhaarOtpGenerationResponse> {
    return this.http.post<Scoreme_AadhaarOtpGenerationResponse>(ScoremeAadhaarOtpGeneration, requestDTO)
  }

  Scoreme_AadhaarOtpVerification(requestDTO: Scoreme_AadhaarOtpVerificationRequestDTO): Observable<Scoreme_AadhaarOtpVerificationResponse> {
    return this.http.post<Scoreme_AadhaarOtpVerificationResponse>(ScoremeAadhaarOtpVerification, requestDTO)
  }

  //Bureau API's
  Bureau_DigilockerGenerateAuthUrl(requestDTO: BureauDigilockerGenerateAuthUrlRequestDTO): Observable<BureauDigilockerGenerateAuthUrlResponse> {
    return this.http.post<BureauDigilockerGenerateAuthUrlResponse>(BureauDigilockerGenerateAuthURL, requestDTO)
  }
  
  Bureau_DigilockerGetDetails(requestDTO: BureauDigilockerGetDetailsRequestDTO): Observable<BureauDigilockerGetDetailsResponse> {
    return this.http.post<BureauDigilockerGetDetailsResponse>(BureauDigilockerGetDetails, requestDTO)
  }

  // Digio APIs

  Digio_PanVerification(
    requestDTO: DigioPanVerificationRequestDTO
  ): Observable<DigioPanVerificationResponseDTO> {
    return this.http.post<DigioPanVerificationResponseDTO>(
      DigioKyc_PanVerification,
      requestDTO
    );
  }

  Digio_GSTVerification(
    requestDTO: DigioGSTVerificationRequestDTO
  ): Observable<DigioGSTVerificationResponseDTO> {
    return this.http.post<DigioGSTVerificationResponseDTO>(
      DigioKyc_GSTVerification,
      requestDTO
    );
  }

  Digio_PANToGSTVerification(
    requestDTO: DigioPANToGSTVerificationRequestDTO
  ): Observable<DigioPANToGSTVerificationResponseDTO> {
    return this.http.post<DigioPANToGSTVerificationResponseDTO>(
      DigioKyc_PANToGSTVerification,
      requestDTO
    );
  }

  Digio_BankAccountVerification(
    requestDTO: DigioBankAccountVerificationRequestDTO
  ): Observable<DigioBankAccountVerificationResponseDTO> {
    return this.http.post<DigioBankAccountVerificationResponseDTO>(
      DigioKyc_BankAccountVerification,
      requestDTO
    );
  }

  Digio_BankStatementAnalysis(
    file: File,
    emailId: string
  ): Observable<DigioBankStatementAnalysisResponseDTO> {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('email_id', emailId);

    return this.http.post<DigioBankStatementAnalysisResponseDTO>(
      DigioKyc_BankStatementAnalysis,
      formData
    );
  }
}
